/**
 * @file The small, upper-case, letter-spaced secondary title of an analytics
 * card, as the design draws "BOOKED" or "SALES CREDIT BY PERSON — …".
 * Consumers: `AnalyticsTile`, the Overview's chart, pipeline and credit table
 * cards, the Reports cards, and the Home tiles, Needs me and My tasks. Given a metric
 * `description`, the title carries its label and definition as a tooltip. The
 * text stays as written in the DOM, so an accessible name reads mixed case;
 * only CSS upper-cases it.
 */
import { FC } from 'react';
import { Tooltip, Typography, theme } from 'antd';

import type { AnalyticsMetricDescription } from '@/analytics';

import FlexCol from '../atoms/FlexCol';

const { Text } = Typography;

const LETTER_SPACING = '0.08em';

export const AnalyticsCardTitle: FC<{
  title: string;
  description?: AnalyticsMetricDescription;
}> = ({ title, description }) => {
  const { token } = theme.useToken();
  const text = (
    <Text
      type="secondary"
      strong
      style={{
        fontSize: token.fontSizeSM,
        textTransform: 'uppercase',
        letterSpacing: LETTER_SPACING,
      }}
    >
      {title}
    </Text>
  );
  if (description === undefined) return text;
  return (
    <Tooltip
      title={
        <FlexCol gap={0}>
          <Text strong>{description.label}</Text>
          <Text>{description.definition}</Text>
        </FlexCol>
      }
    >
      {text}
    </Tooltip>
  );
};
